"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.isMdot = isMdot;

_Object$defineProperty(exports, "matchWindow", {
  enumerable: true,
  get: function get() {
    return _MatchWindow.default;
  }
});

_Object$defineProperty(exports, "Media", {
  enumerable: true,
  get: function get() {
    return _Media.default;
  }
});

var _MatchWindow = _interopRequireDefault(require("./MatchWindow"));

var _Media = _interopRequireDefault(require("./Media"));
/* eslint-disable import/prefer-default-export */


function isMdot() {
  return (0, _MatchWindow.default)({
    max: 'sm'
  });
}